import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactService } from 'api-services/contact.service';
import { AdminDashboardRequest, AdminDashboardResponse } from 'models';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';
import { ContactDashboardStoreProcedure, ngbModalOptions, ngbModalOptionsLG } from 'shared/constant';
import { EmailNotificationComponent } from './email-notification/email-notification.component';
import { EmailNotification } from 'models/admin-dashboard/admin-dashboard-request.model';
import { SharedService } from 'services/shared.service';
import { RoleService } from 'services/role.service';
import { Router } from '@angular/router';
import { EmailNotificationFilter } from 'models/email-notification.model';
@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.css']
})
export class AuditLogComponent implements OnInit {


  @Input() userId: number;
  darkScrollbarOptions: MCustomScrollbar.CustomScrollbarOptions = { axis: 'y', theme: 'light', setHeight: 257};
  tabActive = "#emailNotification";
  allDataLoaded = false;
  totalCount = 0;
  request: AdminDashboardRequest = {
    jsonRequest: '',
    code:ContactDashboardStoreProcedure.GetContactDashboardNIPRActivity
  };

   emailNotificationFilter: EmailNotificationFilter = {
      userId: null,
      pageNumber: 1,
     pageSize: 20,
      isDashboard:true
    } as EmailNotificationFilter;

  activeList: boolean = false;
  activeContactUserId : string = localStorage.getItem('activeContactUserId');
  EmailNotificationList: EmailNotification[] = []
  dashboardAPIResponse: AdminDashboardResponse;
  showLoader:boolean = false;
  isIndividualUser = false;
  selectedRecordId: number = null;
  constructor(private mScrollbarService: MalihuScrollbarService, private contactService: ContactService, private modalService: NgbModal,private sharedService: SharedService,private roleService: RoleService, private router: Router) { }
 
  onScroll(event: any) {
   if (this.showLoader || this.allDataLoaded) return;
    const element = event.target;
    const atBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      this.emailNotificationFilter.pageNumber++;
       this.ngOnInit();
    }
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.request.contactId = this.userId;
    this.isIndividualUser = this.roleService.isIndividualUser;
      this.emailNotificationFilter.userId=this.userId;
    if (this.userId > 0) {
      this.contactService.producerLincenseExpireEmailNotificationList(this.emailNotificationFilter, false).subscribe
        ((res: EmailNotification[]) => {
           this.activeList = true;
           this.totalCount = res[0]?.totalCount;
          this.showLoader = false;
           let EmailNotificationList = res.map(el => ({
            ...el,
            sentOn: this.sharedService.convertUTCTimeToLocalTime(el.sentOn)
          }))
          this.EmailNotificationList = [...this.EmailNotificationList, ...EmailNotificationList];
          
          if (this.EmailNotificationList.length >= this.totalCount) {
            this.allDataLoaded = true;
          }
        });
    }
    else {
      this.contactService.adminLincenseExpireEmailNotificationList(this.emailNotificationFilter,false).subscribe
        ((res: EmailNotification[]) => {
          this.activeList = true;
          this.showLoader = false;
          this.activeList = true;
          this.totalCount = res[0]?.totalCount;
          let EmailNotificationList = res.map(el => ({
            ...el,
            sentOn: this.sharedService.convertUTCTimeToLocalTime(el.sentOn)
          }))
          this.EmailNotificationList = [...this.EmailNotificationList, ...EmailNotificationList];
          if (this.EmailNotificationList.length >= this.totalCount) {
              this.allDataLoaded = true;
          }
        });
    }
  }

  openEmailNotificationModal(id) {
    const modalRef = this.modalService.open(EmailNotificationComponent, ngbModalOptionsLG);
    modalRef.componentInstance.emailNotificationLogId = id;
    modalRef.result.then((data) => {

    });
  }

  getSelectedTab(event){
    this.tabActive = event.srcElement.hash != undefined? event.srcElement.hash : this.tabActive;
  }

  viewActivityReport() {
    localStorage.setItem('resportUserId' , this.userId?.toString())
    this.router.navigate(['/reports/activity-log-report']);
  }


   viewEmailNotificationReport() {
    localStorage.setItem('resportUserId' , this.userId?.toString())
    this.router.navigate(['/reports/email-notifications-log-report']);
  }
  ngOnDestroy() {
    this.mScrollbarService.destroy('#audit-list');
  }
}
